import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import API from "../services/api";

const ModuleContext = createContext(null);

export function ModuleProvider({ children }) {
  const [modules, setModules] = useState({});
  const [loading, setLoading] = useState(true);

  const refreshModules = useCallback(async () => {
    try {
      const res = await API.get("/api/module-settings");
      const map = {};
      (Array.isArray(res.data) ? res.data : []).forEach((m) => {
        map[m.moduleKey] = !!m.enabled;
      });
      setModules(map);
    } catch {
      setModules({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshModules();
  }, [refreshModules]);

  const isModuleEnabled = useCallback((key) => modules[key] !== false, [modules]);

  const value = useMemo(() => ({ modules, loading, isModuleEnabled, refreshModules }), [modules, loading, isModuleEnabled, refreshModules]);
  return <ModuleContext.Provider value={value}>{children}</ModuleContext.Provider>;
}

export function useModules() {
  const ctx = useContext(ModuleContext);
  return ctx || { modules: {}, loading: false, isModuleEnabled: () => true, refreshModules: () => {} };
}
